import angular from 'angular';
import constants from 'app/constants';
import {
  ecatDataService,
  ecatSharedModelService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
} from 'app/services';
import {
  alerts,
  confirmDialog,
} from 'app/components/global';

import levelControl from './levelControl';
import controller from './component-level.controller';
import directive from './component-level.directive';


export default angular.module('app.components.advisory.ecat.componentLevel', [
  alerts,
  ecatDataService,
  ecatSharedModelService,
  confirmDialog,
  constants,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
  levelControl,
])
  .directive('ecatComponentLevel', directive)
  .controller('ComponentLevelController', controller)
  .name;

console.log('app.components.advisory.ecat.componentLevel created');
